import { useEffect, useRef, useCallback, useState } from 'react';

export const useMonitoringDataWithInterval = (
  fetchFunction,
  intervalMs,
  dependencies = [],
) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const intervalRefId = useRef(null);
  const isMountedRef = useRef(true);

  const executeFetch = useCallback(async () => {
    try {
      setIsLoading(true);
      const result = await fetchFunction();

      if (isMountedRef.current) {
        setData(result);
      }
    } catch (err) {
      if (isMountedRef.current) {
        console.error('Error fetching monitoring data:', err);
      }
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  }, [fetchFunction]);

  const reload = useCallback(() => {
    executeFetch();
  }, [executeFetch]);

  useEffect(() => {
    executeFetch();

    if (intervalMs > 0) {
      intervalRefId.current = setInterval(executeFetch, intervalMs);

      return () => {
        if (intervalRefId.current) {
          clearInterval(intervalRefId.current);
        }
      };
    }

    return () => {
      if (intervalRefId.current) {
        clearInterval(intervalRefId.current);
      }
    };
  }, [executeFetch, intervalMs]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      if (intervalRefId.current) {
        clearInterval(intervalRefId.current);
      }
    };
  }, []);

  return { data, isLoading, reload };
};
